import { type EditorValue, parseDraftString } from '@octopus-do/octopus-editor'

import { isEditorValue } from '@/utils'

// todo: make backend comments migration

const isDraftjsString = (content: string) =>
  content.startsWith('{') && content.endsWith('}')

// Тип полей обещает строку, но те же поля несут готовое значение редактора,
// когда контент записал публичный API (OCT-4759). Поэтому хелпер отдаёт
// EditorValue на любом входе: исключение здесь уносило артборд в белый экран.
export const parseEditorContent = (
  content: EditorValue | string | null
): EditorValue => {
  if (isEditorValue(content)) {
    return content
  }

  if (!content || typeof content !== 'string') {
    return []
  }

  if (isDraftjsString(content)) {
    return parseDraftString(content)
  }

  try {
    const parsed = JSON.parse(content)

    return isEditorValue(parsed) ? parsed : []
  } catch {
    return []
  }
}
